import React, { lazy, useEffect } from 'react';
import { submitMSISDNAction, pinFlowMatch, submitPinAction, usePinFlowState } from 'ouisys-engine/pinFlow';
import { useStrategyState } from 'ouisys-engine/strategy';
import { useRootContext } from '../../providers/RootContext';
import { PricePoint, defineMessages, TopLegals } from 'ouisys-component-library';
import { FormattedMessage, legals } from '../../localization';
import { useDispatch } from '../../__doNotModify/store';
import PINEntryStep from '../../components/PINEntryStep';
import { handleAutoSubmitMsisdn } from 'ouisys-engine/utilities/handleSubmitNumber';
import { useSelector } from 'react-redux';
// error messages messages which might come from backend
const defaultMessages = defineMessages({
  InvalidMSISDN: {
    id: 'InvalidMSISDN',
    defaultMessage: 'This mobile number is incorrect, try again'
  },
  AlreadySubscribed: {
    id: 'AlreadySubscribed',
    defaultMessage: 'You are already a subscriber!'
  },
  UnknownError: {
    id: 'UnknownError',
    defaultMessage: 'An unknown error occurred.'
  },
  InvalidPIN: {
    id: 'InvalidPIN',
    defaultMessage: 'Please enter the correct PIN that you received on your phone'
  },
  TooEarly: {
    id: 'TooEarly',
    defaultMessage: 'You must first submit a mobile number'
  },
  didnt_receive_pin_yet: {
    id: 'didnt_receive_pin_yet',
    defaultMessage: "Didn't receive PIN yet?"
  }
});

const PhoneNumberEntryStep = lazy(() => import('../../components/PhoneNumberEntryStep'));

const PinFlow: React.FC = () => {
  const pinFlowState = usePinFlowState(useSelector);
  const strategyState = useStrategyState(useSelector);

  const { isHeaderEnrichmentSuccess } = strategyState?.data || {};
  const { locale, config, setMsisdn, msisdn } = useRootContext();
  const dispatch = useDispatch();

  const onEndMsisdn = (msisdn: string) => {
    dispatch(submitMSISDNAction({ window, msisdn, extraParams: { antifraud_btn_id: 'AFsubmitbtn' } }));
  };
  const onEndPin = (pin) => {
    dispatch(
      submitPinAction({
        window,
        msisdn,
        pin,
        extraParams: { antifraud_btn_id: 'AFsubmitbtn' }
      })
    );
  };

  useEffect(() => {
    handleAutoSubmitMsisdn({
      window,
      msisdnValue: msisdn,
      dispatch,
      submitMSISDNAction,
      isHeaderEnrichmentSuccess
    });
  }, []);

  return (
    <div className="flow-pin">
      {/* <TopLegals className="top-legals" locale={locale} legals={legals} /> */}
      {pinFlowMatch({
        msisdnEntry: (rds) => <PhoneNumberEntryStep rds={rds} onEnd={onEndMsisdn} />,
        pinEntry: (rds) => <PINEntryStep onEnd={onEndPin} rds={rds} />
      })(pinFlowState)}
      <PricePoint className="price-point" locale={locale} legals={legals} />
    </div>
  );
};

export default PinFlow;
